export const typeDefs = `
  type Filter {
    id: ID!,
    FILTER_publisherBookstoreFilterChecked: [],
    FILTER_publisherUfFilterChecked: [],
    publisherBookFilterChecked: String [],
    publisherBookstoreFilterChecked: String [],
    publisherEconomicGroupFilterChecked: String [],
    publisherPublisherFilterChecked: String [],
    publisherStampFilterChecked: String [],
    publisherBookFilterChecked: String [],
    publisherUfFilterChecked: String [],
  }

  type Query {
    filters: [Filter],

  }
  type Mutation {
    addFilterPublisherUfFilterChecked(text: String!): Filter
  }

`;


// WEBPACK FOOTER //
// ./src/graphql/typedefs.tsx